import { WhatsAppButton } from './WhatsAppButton';

interface AppWrapperProps {
  children: React.ReactNode;
}

export function AppWrapper({ children }: AppWrapperProps) {
  return (
    <>
      {children}
      <div className="fixed bottom-6 left-6 z-50">
        <WhatsAppButton />
      </div>
    </>
  );
}